export const iconFontAwesomeGamingWandSparkles = (
	<i className="fa-solid fa-wand-sparkles"></i>
);
